import { queryAll, query, fromId } from '../utils/utils.js';


export class CardCollection {

    constructor() {
        console.log('[BHS] - Card Collection');

        let hasCardCollection = false;
        
        setTimeout(() => {
            queryAll('.card-collection, .hits-holder').forEach((cardCollection) => {

                this.normalizeCardHeight(cardCollection);
                hasCardCollection = true;
            });
        }, 250 );

        if( hasCardCollection ) {
            window.addEventListener('resize', (e) => {
                queryAll('.card-collection, .hits-holder').forEach((cardCollection) => {
                    this.normalizeCardHeight(cardCollection);
                });
            });
        }

        // make card-block items clickable //
       queryAll('.card-block .item').forEach((card) => {
            const button = card.querySelector('.bhs-link-button');
            if (button) {
                card.addEventListener('click', (e) => {
                    button.click();
                });
                card.addEventListener('mouseover', (e) => {
                    button.classList.add('hover');
                });
                card.addEventListener('mouseout', (e) => {
                    button.classList.remove('hover');
                });
            }
        });

        // make provider cards clickable //
        queryAll('.provider-card').forEach((card) => {
            const button = card.querySelector('.bhs-link-button');
            if( button ) {
                card.addEventListener('click', (e) => {
                    button.click();
                });
                card.addEventListener('mouseover', (e) => {
                    button.classList.add('hover');
                });
                card.addEventListener('mouseout', (e) => {
                    button.classList.remove('hover');
                });
            }
        });

        // make collection-grid items clickable //
        queryAll('.collection-grid .items .card').forEach((card) => {
            const button = card.querySelector('.bhs-link-button');

            card.querySelectorAll('a').forEach((a) => {

                if( !a.classList.contains('bhs-link-button') ) {
                    a.addEventListener('click', (e) => {
                        e.stopPropagation();
                    });
                }

            });

            if (button) {
                card.addEventListener('click', (e) => {
                    button.click();
                });
                card.addEventListener('mouseover', (e) => {
                    button.classList.add('hover');
                });
                card.addEventListener('mouseout', (e) => {
                    button.classList.remove('hover');
                });
            }
        });

    }

    normalizeCardHeight(cardCollection) {

        const cards = cardCollection.querySelectorAll('.card');
        // make all same height
        let highestCardHeight = 0;
        cards.forEach((card) => {
            const cardHeight = card.getBoundingClientRect().height;
            const cardOuterHeight = card.offsetHeight;
            const cardH = (cardHeight > cardOuterHeight) ? cardHeight : cardOuterHeight;

            if (cardH > highestCardHeight) {
                highestCardHeight = cardH;
            }
        }   );

        cards.forEach((card) => {
            card.style.height = highestCardHeight + 'px';
        });
    }

}
